<script setup lang="ts">
import { useI18n } from "vue-i18n"

const { t } = useI18n()
</script>

<template>
    <div class="notfound-container">
        <h1>
            404
        </h1>
        <h5>
            {{ t("errors.not_found.title") }}
        </h5>
    </div>
</template>

<style lang="scss" scoped>
.notfound-container {

    @include flex(2.4rem, column, center, center);

    height: 100vh;
}
h1 {
    @include getFont('h1');
    color:var(--blue);
}
h5 {
    @include getFont('c1-bold');

    color:var(--gs-300);
}
</style>
